import Mensagens from "../components/Mensagens";

export function imprimirRetorno(fetch, ret, setLoading) {
    if (!!ret?.rota) {

        if (!!setLoading) {
            setLoading(true);

            fetch().post(`/imprimir/pdv/${ret.rota.toLowerCase()}`, ret.dados).then(() => {
                setLoading(false);

                Mensagens.showSucesso("Impressão realizada com sucesso!");
            }).catch(error => {
                const msg = error && error.response && error.response.status === 400 && error.response.data ? error.response.data : "Falha na conexão";
                Mensagens.showErro(msg);
                setLoading(false);
            });
        }
        else
            fetch().post(`/imprimir/pdv/${ret.rota.toLowerCase()}`, ret.dados).catch(console.log);

    }
}